@if (blur) {
  <span isDemoEnabled class="row flex-12 text-start text-break fs-xs text-lightgray"
    >{{ value }}{{ value ? unit : '' }}</span
  >
} @else {
  <span class="row flex-12 text-start text-break fs-xs text-lightgray"
    >{{ value }}{{ value ? unit : '' }}</span
  >
}
<span class="row text-start fs-2xs">{{ description }}</span>
